import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicAdmissionType2 } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_ADMISSION_TYPE_2_CONDITION_ID = 'admissionType2AT';
export const AtFilterConditionAdmissionType2PluginType: FilterConditionPluginSpecification<
  AtVirtualClinicAdmissionType2[],
  AtFilterConditionAdmissionType2Dto,
  AtAdmissionType2Condition
> = {
  type: 'admissionType2',
  category: 'case',
  displayName: { de: 'Aufnahmeart 2' },
  sortingIndex: 3,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionAdmissionType2Dto,
  ): FilterConditionPluginImpl<AtVirtualClinicAdmissionType2[]> {
    return new AtFilterConditionAdmissionType2Plugin(obj.admissionType2);
  },
  fromCondition(
    jsonObj: AtAdmissionType2Condition,
  ): FilterConditionPluginImpl<AtVirtualClinicAdmissionType2[]> {
    return new AtFilterConditionAdmissionType2Plugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicAdmissionType2[]> {
    return new AtFilterConditionAdmissionType2Plugin([]);
  },
};

export class AtFilterConditionAdmissionType2Plugin extends FilterConditionPluginImpl<
  AtVirtualClinicAdmissionType2[],
  AtFilterConditionAdmissionType2Dto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicAdmissionType2[],
    AtFilterConditionAdmissionType2Dto,
    AtAdmissionType2Condition
  > = AtFilterConditionAdmissionType2PluginType;

  constructor(protected admissionType2: AtVirtualClinicAdmissionType2[]) {
    super(AtFilterConditionAdmissionType2PluginType.type);
  }

  clone(): AtFilterConditionAdmissionType2Plugin {
    return new AtFilterConditionAdmissionType2Plugin([...this.admissionType2]);
  }

  override equals(other: AtFilterConditionAdmissionType2Plugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.admissionType2, other.admissionType2)
    );
  }

  override validationToText(): string {
    if (this.admissionType2.length === 0) {
      return 'Mindestens eine Aufnahmeart auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtAdmissionType2Condition(this.admissionType2, []);
  }

  toText(): string | null {
    return this.admissionType2.length === 2
      ? 'eine Aufnahmeart 2'
      : `${this.admissionType2.length} Aufnahmearten 2`;
  }

  toJSON(): AtFilterConditionAdmissionType2Dto | null {
    return {
      type: this.type,
      admissionType2: this.admissionType2,
    };
  }

  toValue(): AtVirtualClinicAdmissionType2[] {
    return this.admissionType2;
  }
}

export class AtAdmissionType2Condition extends BdContentCondition<AtVirtualClinicAdmissionType2> {
  constructor(
    includes: AtVirtualClinicAdmissionType2[],
    excludes: AtVirtualClinicAdmissionType2[],
  ) {
    super(AT_ADMISSION_TYPE_2_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionAdmissionType2Dto {
  type: string;
  admissionType2: AtVirtualClinicAdmissionType2[];
}
